import { client as request } from "./request";
import Holiday from "@/models/holiday";
import parseDate from "@/helpers/parseDate";

export interface HolidayInput {
  name: string;
  date: string;
}

function createHoliday(params: HolidayInput): Holiday {
  return new Holiday({
    ...params,
    date: parseDate(params.date)
  });
}

/**
 * 国民の祝日を取得する
 * @param year 対象の年 yyyy
 */
export async function getPublicHolidays(year: string) {
  const holidays = await request.get("get_public_holidays.php", {
    year
  });
  return holidays.map(createHoliday);
}
